export const textTran: any = {
    us: {
        btnText: 'Subscribe',
        placeholder: 'Email',
        tipsEmpty: 'Please enter your email address.',
        tipsTypeError: 'Please enter a valid email address (Example: name@domain.com).',
        successTips: '구독해 주셔서 감사드립니다!',
    },
    kr: {
        btnText: '구독하기',
        placeholder: '이메일 주소',
        tipsEmpty: '이메일 주소를 입력하십시오。',
        tipsTypeError: '올바른 전자 메일 주소를 입력하십시오 (예:name@domain.com)。',
        successTips: '구독해 주셔서 감사드립니다!',
    },
    jp: {
        tipsCheck: 'EcoFlow のプライバシーポリシーと利用規約をお読みになり、同意してください',
    },
};
